import { ImageLibraryAsset, OneOfLibraryAssets, VideoLibraryAsset } from '@domain/brand/brand-library';

export function isImageLibraryAsset(asset: unknown): asset is ImageLibraryAsset {
    return !!asset && typeof asset === 'object' && 'original' in asset;
}

export function isVideoLibraryAsset(asset: OneOfLibraryAssets | undefined): asset is VideoLibraryAsset {
    return !!asset && 'durationInMilliseconds' in asset;
}
